import React from "react";

const category = [
  { id: 1, name: "Legal", displayOn: ["en", "cn", "ru"] },
  { id: 2, name: "Construction", displayOn: ["en", "cn", "ru"] },
  { id: 3, name: "Rental Program", displayOn: ["en", "cn", "ru"] },
  { id: 4, name: "Property Management", displayOn: ["en", "cn", "ru"] },
  { id: 5, name: "Privileges", displayOn: ["en", "cn", "ru"] },
  {
    id: 6,
    name: "Infrastructure & Common Areas",
    displayOn: ["en", "cn", "ru"],
  },
  { id: 7, name: "Financing", displayOn: ["en", "cn", "ru"] },
];

const faqs = [
  {
    categoryId: 1,
    question: "What types of ownership are available?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            The various types of ownership available depend upon the type of
            property purchased and are set out in more detail below:
          </p>
          <ul>
            <li>
              <strong> Cassia Phuket</strong>
              <p>
                This is a development consisting of leasehold apartments
                offering a maximum period of 30 years as permitted by law and
                are renewable.
              </p>
            </li>
            <li>
              <strong> Laguna Village Villas</strong>
              <p>
                This is a development consisting of condominiums under the
                Condominium Act. Condominiums can be acquired on both a
                leasehold and freehold basis. However, the number of freeholds
                held by foreigners in a condominium is limited to 49% of the
                total area of the units, excluding the area of the registered
                common property.
              </p>
            </li>
            <li>
              <strong> The Lofts at Laguna Village</strong>
              <p>
                This is a development consisting of leasehold apartments
                offering the same lease as described above for Cassia Phuket.
              </p>
            </li>
            <li>
              <strong>
                Laguna Village Townhomes and Laguna Village Residences
              </strong>
              <p>
                These landed properties are available on a 30 years leasehold
                basis and are renewable for the land for foreigners and freehold
                ownership of the building. According to Thai Law, foreigners may
                have ownership of buildings developed upon the land leased by
                them, but not the land itself. Land may be available for
                freehold ownership for Thai buyers.
              </p>
            </li>
            <li>
              <strong> Banyan Tree Villas</strong>
              <p>
                As these villas are an integral part of the exclusive Banyan
                Tree Phuket Resort, land is offered on a 30 year leasehold (the
                maximum period) as permitted by law and are renewable. However,
                the buildings are sold as freehold.
              </p>
            </li>
            <li>
              <strong> Dusit Thani Pool Villas</strong>
              <p>
                As these villas are an integral part of the exclusive Dusit
                Thani Laguna Phuket, land is on a 30 year leasehold (the maximum
                period) as permitted by law and are renewable. However, the
                buildings are sold as freehold.
              </p>
            </li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Доступны различные формы собственности в зависимости от типа
            недвижимости. Полный список предложений приведен ниже:
          </p>
          <ul>
            <li>
              <strong> Cassia Пхукет</strong>
              <p>
                Это комплекс апартаментов с правом владения аренды, в
                соответствии с законом с максимальным сроком на 30 лет с
                последующим продлением аренды.
              </p>
            </li>
            <li>
              <strong> Виллы Laguna Village Villas</strong>
              <p>
                Объекты попадают под юрисдикцию закона, согласно которого
                недвижимость может быть приобретена на правах аренды или
                оформлена как частная собственность. Но процент владения,
                находящихся в собственности иностранцев ограничивается до 49% от
                общей площади, за исключением площади зарегистрированной для
                общего пользования.
              </p>
            </li>
            <li>
              <strong> Лофты в Laguna Village</strong>
              <p>
                Лофты в Laguna Village предлагаются на условиях аренды на тех же
                условиях что и об Cassia Пхукет.
              </p>
            </li>
            <li>
              <strong>
                Таунхаусы Laguna Village Townhomes и резиденции Laguna Village
                Residences
              </strong>
              <p>
                Эта недвижимость предлагается на правах аренды земли на 30 лет
                для иностранцев, с последующим продлением аренды и полного права
                собственности для постройки. Согласно тайскому законодательству,
                иностранцы могут приобретать здания, спроектированные на
                арендованной земле, но не имеют прав полного владения на саму
                землю.
              </p>
            </li>
            <li>
              <strong> Виллы Banyan Tree Villas</strong>
              <p>
                Поскольку эти виллы являются неотъемлемой частью эксклюзивного
                курорта Banyan Tree Phuket Resort, земля предоставляется только
                на правах аренды на 30 лет с последующим продлением аренды. В то
                время как здания оформляются как частная собственность.
              </p>
            </li>
            <li>
              <strong> Виллы с бассейном Dusit Thani Pool Villas</strong>
              <p>
                Поскольку эти виллы являются неотъемлемой частью эксклюзивного
                курорта Dusit Thani Laguna Phuket,) земля предоставляется только
                на правах аренды на 30 лет с последующим продлением аренды. В то
                время как здания оформляются как частная собственность.
              </p>
            </li>
          </ul>
        </div>
      ),
      cn: (
        <div>
          <p>在乐古浪，购买不同类型的房产有不同类型的产权，具体规定如下：</p>
          <ul>
            <li>
              <strong> 悦梿普吉</strong>
              <p>
                本开发项目为租赁产权项目，租赁权需要经过政府注册（按目前法律规定租赁最大期限为30年）并可以续租。
              </p>
            </li>
            <li>
              <strong> 乐古浪乡村联排别墅</strong>
              <p>
                本开发项目为共管式公寓。共管式公寓的所有权可以是租赁持有，也可以是永久持有。但是，外籍人士持有永久产权的公寓单位数量不得超过所有公寓单位总面积的49%，不包括已登记的公共物业的面积。
              </p>
            </li>
            <li>
              <strong> 乐古浪乡村阁楼</strong>
              <p>
                本开发项目为租赁产权项目，提供与上述悦梿普吉相同的租赁使用形式。
              </p>
            </li>
            <li>
              <strong>乐古浪乡村联体别墅和乐古浪乡村独立别墅</strong>
              <p>
                对于外籍人士，这两种类型的房产提供租赁产权（按目前法律规定租赁最大期限为30年）并可以续租。以及在其租赁土地上所开发建筑物的所有权。根据泰国法律，外籍业主可能获得在其租赁土地上所开发建筑物的所有权，但没有土地本身的所有权。
              </p>
            </li>
            <li>
              <strong> 悦榕庄别墅</strong>
              <p>
                由于这些别墅是独有的普吉岛悦榕度假村不可分割的一部分，所以开发项目为租赁产权项目（按目前法律规定租赁最大期限为30年）并可以续租。以及在其租赁土地上所开发建筑物的所有权。根据泰国法律，外籍业主可能获得在其租赁土地上所开发建筑物的所有权，但没有土地本身的所有权。
              </p>
            </li>
            <li>
              <strong> 都喜天阙泳池别墅</strong>
              <p>
                由于这些别墅是独有的普吉岛乐古浪都喜天阙度假村不可分割的一部分，所以开发项目为租赁产权项目（按目前法律规定租赁最大期限为30年）并可以续租。以及在其租赁土地上所开发建筑物的所有权。根据泰国法律，外籍业主可能获得在其租赁土地上所开发建筑物的所有权，但没有土地本身的所有权。
              </p>
            </li>
          </ul>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question:
      "What are the costs associated with the lease / freehold registration?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>These are outlined below:</p>
          <ul>
            <li>
              <strong> Leasehold land title</strong>
              <p>
                Lease registration fees and stamp duty (currently 1.1% of the
                land rental or lease premium) is payable to the Land Department
                upon registration of the lease.
              </p>
            </li>
            <li>
              <strong> Freehold building title</strong>
              <p>
                Freehold registration fee (2% of the appraisal price of
                building) is payable to the Land Department upon transfer and
                registration of title of the building. The appraisal price is
                calculated relative to the government’s tax assessment value
                which is generally well below market value. Other applicable
                taxes upon transfer and registration of freehold building title
                are:
              </p>
              <ul>
                <li className="white-circle">
                  <strong>Corporate Income Tax</strong>
                </li>
                <p>
                  (currently 1.0% of the selling price or appraisal price,
                  whichever is higher)
                </p>
                <li className="white-circle">
                  <strong>Special Business Tax</strong>
                </li>
                <p>
                  (currently 3.3% of the selling price or appraisal price,
                  whichever is higher)
                </p>
              </ul>
            </li>
          </ul>
          <p>
            The burden between the seller and the purchaser for the above costs
            will be specified in the Lease and/or Sale & Purchase Agreements.
          </p>
          <p>
            <small>
              <em>
                Note: applicable tax rates are current at the date of issue of
                this FAQ and may be subject to changes. The unit owner shall be
                responsible for any income and any other taxes, duties and fees
                of whatever nature which may be levied by relevant authorities
                on the unit in connection with the rental. All unit owners are
                advised to seek their own tax advice in this regard.
              </em>
            </small>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>Список всех затрат приведен ниже：</p>
          <p>
            При регистрации договора аренды в Земельном департаменте необходимо
            оплатить регистрационные сборы и пошлины (в настоящее время 1,1% от
            стоимости аренды).
          </p>
          <ul>
            <li>
              <strong> Регистрация прав собственности</strong>
              <p>
                При передаче и регистрации права собственности на недвижимость в
                Земельный департамент оплачивается регистрационный взнос (2% от
                оценочной стоимости объекта). Оценочная стоимости обычно берется
                с государственного реестра. Как правило, она значительно ниже
                рыночной стоимости объекта. Другими действующими налогами на
                передачу и регистрацию права на свободное владение собственности
                являются：
              </p>
              <ul>
                <li className="white-circle">
                  <strong>Налог на доход для юридических лиц</strong>
                </li>
                <p>
                  (в настоящее время ставка составляет 1.0% от цены продажи или
                  рыночной цены, в зависимости от того, какая из них выше)
                </p>
                <li className="white-circle">
                  <strong>Коммерческий налог</strong>
                </li>
                <p>
                  (в настоящее время ставка составляет 3.3% от цены продажи или
                  рыночной цены, в зависимости от того, какая из них выше)
                </p>
              </ul>
            </li>
          </ul>
          <p>
            Обязательства продавца и покупателя в отношении указанных выше
            расходов описываются в соглашении об аренде и / или договоре
            купле-продажи.
          </p>
          <p>
            <small>
              <em>
                Примечание: обратите внимание на то, что указанные ставки
                налоговых обязательств согласно действующего тайского
                законодательства приведены на дату выпуска данного документа.
                После даты публикации документы ставки и условия оформления
                могут быть изменены.
              </em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>具体条款如下：</p>
          <ul>
            <li>
              <strong> 土地租赁使用权</strong>
              <p>
                租赁使用权登记费和印花税（现为地租或租赁使用费的1.1%）须在登记租赁使用权时向国土资源部缴纳。
              </p>
            </li>
            <li>
              <strong> 建筑永久产权</strong>
              <p>
                永久产权登记费（现为物业估价的2%）须在转让和登记产权时向国土资源部缴纳。估价是相对于政府的税务评估值计算得出，通常远低于市价。转让和登记永久产权时的其他适用税项有：
              </p>
              <ul>
                <li>
                  <strong>企业所得税</strong>
                </li>
                <p>(现为售价或估价的1.0%，以较高者为准)</p>
                <li>
                  <strong>特别营业税</strong>
                </li>
                <p>(现为售价或估价的3.3%，以较高者为准)</p>
              </ul>
            </li>
          </ul>
          <p>
            上述费用中，买卖双方各自承担的费用将在租赁和/或买卖协议中详细说明。
          </p>
          <p>
            <small>
              <em>
                备注：
                请注意，此处的登记费以及某些适用税率适用于现在，根据相关泰国法律有随时更改的可能。
              </em>
            </small>
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: "Is leasehold land transferable?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Leasehold land may be transferred subject to the terms and
            conditions of the agreements. Generally, an assignment fee is
            payable. In addition, the assignee must agree to be bound by the
            terms and conditions contained in the original lease agreement.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Арендованная земля может быть передана в соответствии с положениями
            и условиями соглашения. Как правило, при этом уплачивается пошлина.
            Кроме того, правопреемник должен согласиться соблюдать положения и
            условия, содержащиеся в первоначальном договоре аренды.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            租赁使用的土地可以根据协议的条款和条件进行转让。一般情况下，须支付一笔转让费。
            此外，受让人必须同意接受原租赁协议中所含条款和条件的约束。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: "Can leasehold be upgraded to freehold title?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            This depends upon particular circumstances and is set out in more
            detail below:
          </p>
          <ul>
            <li>
              <strong> Cassia Phuket and the Lofts at Laguna Village</strong>
              <p>
                An apartment may not be upgraded to freehold since the unit is a
                partial lease of the relevant building. Upgrading to a freehold
                basis may only be available should the law change to allow the
                apartment to have separate title deed for each unit or if a
                condominium license is later obtained.
              </p>
            </li>
            <li>
              <strong> Laguna Village Villas</strong>
              <p>
                This may be possible provided that the foreign ownership quota
                is not exceeded (currently 49% of total saleable area). Where
                applicable, an option fee may also be payable (generally based
                upon the lease premium) to upgrade the title.
              </p>
            </li>
            <li>
              <strong>
                Laguna Village Townhomes and Laguna Village Residences
              </strong>
              <p>
                Upgrading from leasehold to freehold title may be available,
                provided that the lessee is eligible under relevant Thai laws
                and regulations to take transfer of and own the land (currently,
                foreigners are prohibited to acquire land on a freehold basis).
              </p>
            </li>
            <li>
              <strong> Banyan Tree Villas</strong>
              <p>
                As these villas are an integral part of the exclusive Banyan
                Tree Phuket Resort, the option to purchase the land on a
                freehold basis is not available.
              </p>
            </li>
            <li>
              <strong> Dusit Thani Pool Villas </strong>
              <p>
                As these villas are an integral part of the exclusive Dusit
                Thani Laguna Phuket, the option to purchase the land on a
                freehold basis is not available.
              </p>
            </li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Это зависит от определенных обстоятельств. Детали изложены ниже：
          </p>
          <ul>
            <li>
              <strong> Лофты в Laguna Village и Cassia Пхукет</strong>
              <p>
                Квартиры не могут быть оформлены в частную собственность, так
                как права на объект оформлены в качестве частичной аренды в
                соответствующем здании. Перевод в собственность будет доступен,
                только если измениться закон, который позволит оформить
                отдельный документ права собственности на каждую квартиру, или
                если будет получен патент на квартиру.
              </p>
            </li>
            <li>
              <strong> Виллы Laguna Village Villas</strong>
              <p>
                Это возможно при условии, что иностранная квота на собственность
                не была превышена 49%. При изменении прав владения также могут
                измениться условия оплаты (как правило, это обусловлено
                дополнительной наценкой на аренду).
              </p>
            </li>
            <li>
              <strong>
                Таунхаусы Laguna Village Town homes и резиденции Laguna Village
                Residences
              </strong>
              <p>
                Переоформление прав аренды на право собственности будет доступно
                в случае изменения закона, если арендатор имеет право на
                принятие, передачу и владение землей в соответствии с тайским
                законам (в настоящее время иностранцам запрещено приобретать
                землю с правом собственности).
              </p>
            </li>
            <li>
              <strong> Виллы Banyan Tree Villas</strong>
              <p>
                Поскольку эти виллы являются неотъемлемой частью эксклюзивного
                курорта Banyan Tree Phuket Resort, оформление земли в частную
                собственность невозможно.
              </p>
            </li>
            <li>
              <strong> Виллы с бассейном Dusit Thani Pool Villas</strong>
              <p>
                Поскольку эти виллы являются неотъемлемой частью эксклюзивного
                курорта Dusit Thani Laguna Phuket, оформление земли в частную
                собственность невозможно.
              </p>
            </li>
          </ul>
        </div>
      ),
      cn: (
        <div>
          <p>这取决于特定的情况，详细规定如下：</p>
          <ul>
            <li>
              <strong> 乐古浪海滨公寓和乐古浪乡村阁楼公寓</strong>
              <p>
                由于公寓中的每个单元都是整栋公寓的相关部分，所以公寓房产是不可以从租赁权转为永久产权的。只有法律变更允许公寓内各单位拥有单独的地契或日后获得共管公寓许可证，才能实现租赁使用权至永久产权的升级。
              </p>
            </li>
            <li>
              <strong> 乐古浪乡村联排别墅</strong>
              <p>
                只要未超过外国人所有权配额，这就是可能的（目前为总面积的49%）。如适用，还可能须支付一笔选购费（一般基于租赁费）才能升级所有权。
              </p>
            </li>
            <li>
              <strong>乐古浪乡村联体别墅和乐古浪乡村独立别墅</strong>
              <p>
                若泰国相关法律法规变更允许承租人拥有土地，则可实现租赁权至永久产权的升级。（目前，泰国禁止外国人获得土地所有权）。
              </p>
            </li>
            <li>
              <strong> 悦榕庄别墅</strong>
              <p>
                由于这些别墅是独有的普吉岛悦榕庄度假村不可分割的一部分，因此这些别墅的土地不能转为永久产权。
              </p>
            </li>
            <li>
              <strong> 都喜天阙泳池别墅</strong>
              <p>
                由于这些别墅是独有的都喜天阙度假村不可分割的一部分，因此这些别墅的土地不能转为永久产权。
              </p>
            </li>
          </ul>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: "Is leasehold land ownership secure?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Our land titles in most cases are free from mortgage and any
            encumbrances. Leasehold land ownership is the preferred method of
            ownership for foreign buyers. Once the lease is registered at the
            Land Department, the right of use to the land will be vested with
            the lessee.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Наши права на землю не являются предметом залога или других
            обязательств, поэтому являются абсолютно безопасным видом
            собственности для иностранных покупателей. Арендатору переходят
            права пользования землей сразу при регистрации договора в Земельном
            департаменте.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            乐古浪的土地大多数情况下没有进行银行抵押和任何产权负担。同时土地的租赁权产权是提供给外籍业主的最佳产权方式。一旦租赁使用权在国土资源部登记后，土地的使用权即归承租人所有。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: "Should I appoint a lawyer to review the agreements?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Our agreements have been used for a number of years and have been
            reviewed by major international law firms. We have our own in-house
            legal team which will assist to clarify any questions you may have
            concerning the agreements. However, should you wish to obtain
            specific advice regarding the structuring of your investment, we
            recommend you consult with a professional legal and/or financial
            adviser.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Наши соглашения используются уже много лет и были рассмотрены
            многими крупными международными юридическими фирмами. У нас есть
            свои юристы, которые могут ответить на любые ваши вопросы по
            договорам. Однако, если вы хотите получить конкретные рекомендации
            по структурированию инвестиций, мы рекомендуем проконсультироваться
            с профессиональным юридическим и / или финансовым консультантом.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            我们的协议已经使用多年，并且已通过各大国际律师事务所的审核。我们拥有自己的内部法律团队，可以协助解答您对协议的任何疑问。但是，如果您希望就您的投资获得详细而具体的意见，建议您咨询专业法律和/或财务顾问。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: "What is the measurement of square wah?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Our agreements indicate the property’s areas with land measurement
            under the Thai system set by the Land Department. The most commonly
            used land measurements are as follows:
          </p>
          <ul>
            <li>One rai equals 1,600 square meters</li>
            <li>One ngan equals 400 square metres</li>
            <li>One square wah equals 4 square metres</li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Мы обязаны указывать площадь земельных участков в соответствии с
            тайской системой, установленной Земельным департаментом. Наиболее
            часто используется следующая система измерения:
          </p>
          <ul>
            <li>Один рай равен 1600 квадратным метрам</li>
            <li>Один нган равен 400 квадратным метрам</li>
            <li>Один квадратный ваа равен 4 квадратным метрам</li>
          </ul>
        </div>
      ),
      cn: (
        <div>
          <p>
            我们的协议依照国土资源部制定的泰制土地度量单位来表示物业的面积。最常用的土地度量单位如下：
          </p>
          <ul>
            <li>1莱（rai）等于1,600平方米</li>
            <li>1干（ngan）等于400平方米</li>
            <li>1平方瓦（wah）等于4平方米</li>
          </ul>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question:
      "When will be the lease / house transfer registration take place?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Approximately 90 days after full payments of the Rental and/or
            Purchase Price of the land and/or buildings have been made providing
            that title deeds have been registered and issued by the Land
            Department. We will notify the lessee / buyer of any required
            documents and fees which will be incurred upon registration.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Примерно через 90 дней после полной оплаты стоимости аренды и
            объекта мы сообщим арендатору / покупателю список необходимых
            документов и сборов, необходимых для регистрации. В случае
            оформления объекта, являющего частью кондоминиума, имущество будет
            передано только при условии регистрации прав собственности в
            Земельном департаменте.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            在国土资源部登记并颁发契据的土地和/或建筑物的租金和/或购买价全部结清后约90天，我们会告知承租人/购买者登记时所需的所有文件档案和费用。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 1,
    question: "What types of Long Term Visas are available for Foreigners?",
    displayOn: ["en"],
    answer: {
      en: (
        <div>
          <p>
            There are various forms of Long Term Visas available to Foreigners
            wishing to stay longer. Please consult with an immigration
            specialist or Thai Embassy/Consulate for more information.
          </p>
          <ul className="dashed">
            <li>
              <strong> 90 day Tourist Visa</strong>
            </li>
            <li>
              <strong> Education Visa –</strong> for families with children
              wishing to enroll in school within Thailand
            </li>
            <li>
              <strong> Business Visa– Non-B Visa – </strong>
              for those employed or doing business in Thailand
            </li>
            <li>
              <strong> Retirement Visa </strong>
              for people aged 50 years or over and meet financial requirements
            </li>
            <li>
              <strong> Marriage Visa </strong>
              for foreigners married to Thai citizen
            </li>
            <li>
              <strong> Thailand Elite Visa - * </strong>
              purchased thru a private company
            </li>
          </ul>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "How long does construction take?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            All construction works are subject to receiving the appropriate
            Government approvals. Generally, it will take approximately 12-18
            months to complete the building and landscaping from the date of
            commencement of construction for townhomes and residences and 18 –
            24 months for larger apartment buildings and hotel villa
            developments.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Все этапы строительных работ согласовываются с соответствующими
            государственными организациями. Как правило, для таунхаусов и жилых
            домов это займет около 12-18 месяцев, чтобы завершить строительство
            и озеленение с даты начала строительства; и 18 - 24 месяцев для
            многоэтажного здания и отельного проекта.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            所有建筑工程必须得到适当的政府批准后方可进行。一般而言，对于联体别墅和独立别墅,
            从开工第一天算起，大约需要12-18个月才能完成建筑和景观绿化。而对于大型的公寓楼以及酒店别墅，需要18-24个月。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: "What is the warranty period offered?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Generally a one year warranty period is offered on the building and
            component parts or accessories from the date of completion of
            construction.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Обычно предлагается один год гарантийного срока предлагается на
            здания и компоненты или аксессуары с даты завершения строительства.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>一般而言，从竣工之日起，对房屋及其构件或配件提供一年保修。</p>
        </div>
      ),
    },
  },
  {
    categoryId: 2,
    question: "Is customization of the building allowed?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            All of our residential properties have been professionally designed
            by leading architects and engineers and construction must be in
            accordance with building permits issued by the Government
            authorities. However, we will consider minor modifications which do
            not breach the construction permit and do not impact the building
            structure such as internal partitions, built-in furniture, wall and
            floor tiles, and do not affect the overall aesthetics of a
            development. Customization options are available with Laguna Village
            Deluxe Residences.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            План всех объектов жилой недвижимость разрабатывается
            профессионалами - ведущими архитекторами и инженерами, а
            строительство ведется в соответствии с выданными государственными
            органами разрешениями на строительство. Тем не менее, мы можем
            внести незначительные изменения, которые не нарушают условия
            полученного разрешения на строительство, и не повлияют на
            конструкцию здания. Обычно это работы, которые не влияют на общую
            эстетику постройки, например, перенос внутренних перегородок и
            изменение деталей внутренней отделки и оформления - встроенная
            мебель, стены и пол и так далее. Возможны варианты персонального
            планирования для Laguna Village Deluxe Residences.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            我们所有的住宅物业均由顶级建筑师和工程师专业设计，并且依照政府机构所颁发的施工许可证进行建造。不过，我们会考虑您提出的微小改动，但前提是这些改动不违背施工许可证，不影响建筑结构（例如内部隔墙，内置式家具，墙面和地面的瓷砖等），并且不影响开发项目的整体美观。乐古浪乡村豪华独立别墅可以选择个性化选项。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question:
      "Is there a rental program available and what are the potential returns?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes, various rental programs are available for many of our property
            developments. The terms and conditions of rental programs and the
            returns may differ depending upon the type of property. Please
            contact the Property Sales Centre for further details.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Да, существуют различные программы аренды. Сроки и условия программы
            аренды, а также сумма получаемого дохода, могут варьироваться в
            зависимости от типа собственности. Пожалуйста, обратитесь в Отдел
            Продаж для уточнения деталей.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            是的，对于我们的很多房产，我们有多种租赁计划可供选择。根据物业的类型，租赁计划的条款和条件以及回报各不相同。请联系物业销售中心，进一步了解详情。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 3,
    question:
      "What are the taxes levied on the rental program that an owner will be subject to?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            A withholding tax is generally deducted from rental distributions
            made which owners earn under the relevant rental scheme agreement.
            Foreign and Thai tax resident owners are subject to 15% and 5%
            withholding tax respectively. A local property tax may also be
            levied upon owners who rent out their properties at the rate of 1%
            of the rental. However, owners receiving a rental income may also be
            liable to lodge a tax return in Thailand in respect of rental income
            earned. For tax related matters pertaining to your investment, we
            recommend you consult with an independent legal and/or financial
            adviser.
          </p>
          <small>
            <em>
              Note: Applicable tax rates are current by may be subject to change
              by the relevant Thai authorities
            </em>
          </small>
        </div>
      ),
      ru: (
        <div>
          <p>
            Налог взыматся с суммы, вырученной владельцем согласно Договора
            аренды. Иностранные граждане, получающие доход с аренды, оплачивают
            налог в размере 15%. Ставка налогообложения для местных жителей
            составляет 5%. Мы не можем проконсультировать вас по вопросам
            налогообложения в полном объеме. Настоятельно рекомендуем
            проконсультироваться с независимым юридическим и / или налоговым
            консультантом.
          </p>
          <small>
            <em>
              Примечание: обратите внимание на то, что указанные ставки
              налоговых обязательств согласно действующего тайского
              законодательства приведены на дату выпуска данного документа.
              После даты публикации документы ставки и условия оформления могут
              быть изменены.
            </em>
          </small>
        </div>
      ),
      cn: (
        <div>
          <p>
            业主需依照《租赁方案协议》为所赚得的租金纳税。出租物业的外籍业主预扣15%的租金所得税；泰籍业主预扣5%的租金所得税。业主出租房产所得租金1%的本地物业税也可能会被收取。我们强烈建议您咨询独立的法律和/或税务顾问。
          </p>
          <small>
            <em>
              备注：请注意，此处的某些适用税率可能会根据泰国法律改变而发生改变。
            </em>
          </small>
        </div>
      ),
    },
  },
  {
    categoryId: 4,
    question:
      "What types of property management services are offered and what is the approximate cost?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            In addition to common area property management, optional property
            management services are available to individual owners. For
            properties in a rental program, these services (such as
            housekeeping, pool cleaning, gardening, routine and preventative
            maintenance, general repairs and pest control) will normally be
            provided as part of the rental program. However, these services are
            also available to non-rental program properties. Please contact the
            Property Sales Centre for further details.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            В дополнение к уходу за общей территорией владельцам недвижимости
            предлагаются дополнительные услуги. Обслуживание объектов,
            участвующих в программе аренды, осуществляется согласно условий
            программы. Сюда включены такие услуги, как уборка, чистка бассейна,
            озеленение, текущее и профилактическое обслуживание, капитальный
            ремонт и борьба с вредителями. Тем не менее, данные услуги доступны
            и для других объектов. Пожалуйста, обратитесь в Отдел продаж для
            уточнения деталей.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            除了公共区域的物业管理之外，我们还为每位业主提供选择性的物业管理服务。对于加入租赁计划的物业，这些服务（例如家政，泳池清洁，园艺，定期和预防性维护，一般维修及病虫害防治）通常作为租赁计划的一部分提供。但是，未加入租赁计划的物业也可以享受这些服务。
            请联系物业销售中心，进一步了解详情。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 5,
    question:
      "What privileges will I receive as an owner of a Laguna Phuket property?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            As an owner of a property in Laguna Phuket, you may be entitled to a
            membership at Laguna Phuket Golf Club (depending on property
            project, not available for Lofts 2-Bedroom at Laguna Village and
            Cassia Phuket apartments).
          </p>
          <p>
            Owners will receive a ‘Sanctuary Club’ card which entitles holders
            to discounts and privileges at all Banyan Tree, Angsana and Laguna
            Resorts worldwide.
          </p>
          <ul>
            <li>
              30% discount on best available rates for hotel accommodation
            </li>
            <li> 25% discount on food and beverage</li>
            <li> 20% discount on golf green fees</li>
            <li> 20% discount on a-la-carte spa menu</li>
            <li> 15% discount on gallery merchandise</li>
            <li> 15% discount on in-house tours</li>
            <li> 15% discount on laundry</li>
            <li> 10% discount airport and ferry terminal transfers</li>
            <li> Priority wait-list on reservations</li>
            <li> Early check-in / late check-out</li>
          </ul>
          <p>Terms and conditions apply.</p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Как владельцу недвижимости в Laguna Phuket, вам предоставляется
            членство в гольф клуб -Laguna Phuket Golf Club (исключая владельцев
            двух спальных Лофтов в Laguna Village и апартаментов в Cassia
            Пхукет).
          </p>
          <p>
            Кроме того, владельцы получают карту эксклюзивного клуба “Banyan
            Tree Sanctuary Club” по которой предоставляются привилегии и скидки
            в отелях Banyan Tree, Angsana и Laguna курортах, спа и галерей в
            разных странах мира включая:
          </p>
          <ul>
            <li>30% скидки от наиболее выгодной цены на проживание в отеле</li>
            <li> 25% скидки на еду и напитки</li>
            <li> 20% скидки от стоимости пользования полем для игры в гольф</li>
            <li> 20% скидки на средства для спа-процедур по выбору</li>
            <li> 15% скидки на покупки в торговой галерее</li>
            <li> 15% скидки на туры организуемые отелем</li>
            <li> 15% скидки на услуги прачечной</li>
            <li>
              10% скидки на поездки из/до аэропорта и причала паромной переправы
            </li>
            <li>
              Приоритетный статус при ожидании свободного номера для
              бронирования
            </li>
            <li> ранний заезд/поздний выезд</li>
          </ul>
          <p>**Могут действовать ограничения.</p>
        </div>
      ),
      cn: (
        <div>
          <p>
            作为普吉岛乐古浪物业的业主，您有资格成为普吉岛乐古浪高尔夫俱乐部的会员。（根据物业项目，不可用于两房的乐古浪乡村阁楼公寓和普吉悦梿公寓）。
          </p>
          <p>
            (此外，业主将收到一张“榕源会俱乐部”会员卡，获得全球所有悦榕庄,悦椿及乐古浪度假村品牌的特权和折扣和特权。)
          </p>
          <ul>
            <li>酒店住宿最优价格7折</li>
            <li> 餐饮7.5折</li>
            <li> 高尔夫果岭费8折</li>
            <li> Spa按摩方式随心选8折</li>
            <li> 零售艺品店商品8.5折</li>
            <li> 酒店提供旅行8.5折</li>
            <li> 洗衣服务8.5折</li>
            <li> 机场及渡船码头接送9折</li>
            <li> 优先预订</li>
            <li> 提早入住/延迟退房</li>
          </ul>
          <p>**遵循附属条款。</p>
        </div>
      ),
    },
  },
  {
    categoryId: 5,
    question: "Who will be entitled to the Golf Club membership?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            For individual buyers: you; your legal spouse and your children (who
            are not over 21 years of age) will be entitled to the Golf Club
            membership. For corporate buyers, the company may nominate 2
            directors who will receive the membership (depending on property
            project).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Для индивидуальных покупателей: вы, ваш законный супруг и ваши дети
            ( не старше 21 года) будет иметь право на членство Golf Club. Для
            корпоративных покупателей, компания может назначить 2-х директоров,
            которые смогут получить членства.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            根据我们现行的政策，如果您以自己的名义购买物业：您，您的合法配偶及子女（21周岁以下）将有资格成为高尔夫俱乐部的会员。但是，只有一个人能够注册高尔夫俱乐部的会籍。如果房产是以公司的名义购买的，该公司的最高执行者须指定将成为会员的人。
          </p>
        </div>
      ),
    },
  },
  {
    categoryId: 6,
    question: "What infrastructure facilities and services are provided?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Being an owner in Asia’s leading resort, a collection of hotels with
            their restaurants, rejuvenating spas, recreation facilities
            (including the acclaimed Laguna Phuket Golf Course) and Canal
            Village shops are all within easy reach via the inter-resort shuttle
            bus and ferry services.
          </p>
          <p>
            The infrastructure facilities and services meet the same high
            standards of the hotels and include:
          </p>
          <ul>
            <li>
              Security 24-hour security guards stationed in each development.
            </li>

            <li>
              Roads and fences – each gated development contains a private
              internal road and a perimeter fence.
            </li>

            <li>
              Electricity – power is provided by the Provincial Electricity
              Authority.
            </li>

            <li>
              Water – each development is supplied with water from reservoirs
              within the complex and/or the Provincial Water Authority.
            </li>

            <li>
              Landscaped area – each development normally contains open space
              for recreational use by owners.
            </li>

            <li>
              Communications – each property is provided with telephone lines.
              Broadband and cable TV connections may be separately arranged.
            </li>

            <li>
              Garbage collection – provided on a daily basis by Laguna Service
              Company.
            </li>

            <li>
              Estate Management – a dedicated estate management office is
              provided to oversee the 24-hour security, garbage collection,
              gardening and landscaping, general cleaning and ongoing
              maintenance of common areas in residential developments. Our
              dedicated staffs are also happy to assist owners with any
              reasonable request.
            </li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Любой владелец недвижимости, cможет с легкостью добраться до отелей,
            ресторанов, салонов, объектов отдыха и досуга (в том числе
            известного гольф-клуба Laguna Phuket Golf Сourse) и магазинов Canal
            Village с помощью бесплатных автобусов и паромов курсирующих по всей
            территории ведущего курорта Азии.
          </p>
          <p>Предлагаемые высококачественные услуги и инфраструктура:</p>
          <ul>
            <li>
              Безопасность - 24-часовая охрана, размещаемая на входе каждого
              участка.
            </li>

            <li>
              Дороги и ограждения - в каждом жилом комплексе проложены
              внутренние дороги, а по периметру установлены ограждения
            </li>

            <li>
              Электроснабжение - электричество поставляется Местным
              департаментом электроснабжения Таиланда.
            </li>

            <li>
              Водопровод - каждое здание подключено к собственному источнику
              воды, к резервуару и/или скважине.
            </li>

            <li>
              Зеленая зона - не менее 5% от общей площади участка
              предоставляется в общее пользование владельцам
            </li>

            <li>
              Коммуникации - каждый дом имеет две внешние телефонные линии.
              Интернет и кабельное телевидение подключаются отдельно.
            </li>

            <li>
              Вывоз мусора – ежедневный вывоз компанией Laguna Service Company.
            </li>

            <li>
              Уход за территорией - специальное Бюро по управлению недвижимостью
              осуществляет надзор за 24-часовой охраной, вывозом мусора,
              озеленением и благоустройством, генеральной уборкой и текущими
              задачами по уходу за местами общего пользования в здании. Наш
              заботливый персонал всегда рад помочь владельцам удовлетворить
              любой разумный запрос.
            </li>
          </ul>
        </div>
      ),
      cn: (
        <div>
          <p>
            作为亚洲顶级度假村的业主，您可以通过免费的度假村内往返班车和轮渡服务，轻松便捷地使用五家豪华酒店及其餐厅，回春水疗会所，休闲设施（包括备受赞誉的普吉岛乐古浪高尔夫球场）及卡娜村购物中心。
          </p>
          <p>所有基础设施和服务具有与酒店匹配的高标准，包括：</p>
          <ul>
            <li>安保 — 所有项目的入口大门处均有保安24小时站岗。</li>

            <li>道路和围墙 — 各门禁社区均有内部私家道路和围墙。</li>

            <li>电力 — 由泰国省级电力局供电。</li>

            <li>供水 — 各项目均设有来自蓄水池和/或深井的独立供水。</li>

            <li>园景区 — 至少划出项目总面积的5%供业主公用。</li>

            <li>
              通讯 — 每套房屋均接有两条外线电话线。
              宽带和有线电视连接需要另行安排。
            </li>

            <li>垃圾收集 — 乐古浪服务公司提供每日垃圾收集服务。</li>

            <li>
              物业管理 —
              设有专门的物业管理部门，对项目的公共区域提供24小时的安全监控，垃圾收集，园艺及景观绿化，基本清洁和日常维护服务。我们的专职人员乐于满足业主的任何合理要求。
            </li>
          </ul>
        </div>
      ),
    },
  },
  {
    categoryId: 6,
    question: "What are the estimated common area charges?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Common area charges are the costs the owners pay for ongoing
            maintenance and upkeep of the common infrastructure and facilities,
            which are provided for their benefit. These are set out in more
            detail below:
          </p>
          <ul>
            <li>
              <strong>
                Cassia Phuket, Lofts at Laguna Village, Laguna Townhomes and
                Laguna Residences
              </strong>

              <p>
                The common areas are managed on behalf of owners by our
                dedicated estate management office. The annual charges that
                apply differ by development depending upon the total expenses
                and the total number of properties within a particular
                development among which the expenses will be proportionately
                divided. Details of the estimated annual fees for a particular
                development can be provided upon request. In addition, a sinking
                fund has been established for each development. The purpose of
                the sinking fund is to accumulate funds for major infrastructure
                repairs and/or improvements which may be undertaken in the
                future. Rather than charge a large upfront amount, contributions
                will be sought on a regular basis so that the fund is built up
                over time.
              </p>
            </li>

            <li>
              <strong> Laguna Village Villas</strong>

              <p>
                The common area is managed by the Condominium Juristic Person
                (CJP). The annual charges are based on the total expenses
                incurred and are divided by the total number of properties on a
                proportionate basis. In addition, a sinking fund has been
                established. The purpose of the sinking fund is to accumulate
                funds for major infrastructure repairs and/or improvements which
                may be undertaken in the future. Rather than charge a large
                upfront amount, contributions will be sought on a regular basis
                so that the fund is built up over time.
              </p>
            </li>

            <li>
              <strong> Banyan Tree Villas</strong>

              <p>
                Common area costs are absorbed by the Banyan Tree as part of
                their normal operating costs.
              </p>
            </li>

            <li>
              <strong> Dusit Thani Pool Villas</strong>

              <p>
                Common area costs are absorbed by the Dusit Thani Laguna Phuket
                as part of their normal operating costs.
              </p>
            </li>
          </ul>
        </div>
      ),
      ru: (
        <div>
          <p>
            Платежи за обслуживание территории используются для планового
            обслуживания и поддержания общих объектов и инфраструктуры в
            надлежащем состоянии. Детальная информация приведена ниже：
          </p>
          <ul>
            <li>
              <strong>
                Cassia Пхукет, Лофты в Laguna Village, Резиденции Laguna Village
                Residences и таунхаусы Laguna Village Townhomes
              </strong>
              <p>
                Уход за территорией общего пользования осуществляется от имени
                владельцев нашей специальной службой. Сумма ежегодных выплат
                основана на общих расходах, которые пропорционально делятся
                между всеми объектами. Информация о предполагаемых ежегодных
                сборах для конкретного объекта предоставляется по запросу. Кроме
                того, для каждого проекта создается амортизационный фонд. Цель
                амортизационного фонда - накопление средств на капитальный
                ремонт инфраструктуры и/или улучшения, которые будет решено
                сделать в будущем. Фонд создается путем незначительных
                поступлений на регулярной основе, что позволяет исключить
                необходимость отплаты крупных сумм при необходимости ремонта.
              </p>
            </li>

            <li>
              <strong> Виллы Laguna Village Villas</strong>

              <p>
                Общая площадь обслуживается юридическим лицом (Condominium
                Juristic Person (CJP). Сумма ежегодных выплат основана на общих
                расходах, которые пропорционально делятся между всеми объектами.
                Информация о предполагаемых ежегодных сборах для конкретного
                объекта предоставляется по запросу. Кроме того, для каждого
                проекта создается амортизационный фонд. Цель амортизационного
                фонда - накопление средств на капитальный ремонт инфраструктуры
                и/или улучшения, которые будет решено сделать в будущем. Фонд
                создается путем незначительных поступлений на регулярной основе,
                что позволяет исключить необходимость отплаты крупных сумм при
                необходимости ремонта.
              </p>
            </li>

            <li>
              <strong> Виллы в Banyan Tree Village</strong>

              <p>
                Общие расходы, являющиеся частью обычных эксплуатационных
                расходов, оплачиваются Banyan Tree.
              </p>
            </li>

            <li>
              <strong> Виллы с бассейном Dusit Thani Pool Villas</strong>

              <p>
                Общие расходы, являющиеся частью обычных эксплуатационных
                расходов, оплачиваются Dusit Thani Laguna Phuket.
              </p>
            </li>
          </ul>
        </div>
      ),
      cn: (
        <div>
          <p>
            公共区域管理费是为了业主的利益而向其收取的公共基础设施和设备的日常维护和养护费用。详细规定如下：
          </p>
          <ul>
            <li>
              <strong>乐古浪乡村联体别墅和乐古浪乡村独立别墅</strong>

              <p>
                公共区域由我们专门的物业管理部门代表业主进行管理。每年的费用因项目的不同而有所不同，根据总费用以及同一项目内的物业总数按比例分摊。特定项目的详细预估年费可应要求提供。此外，各项目还将设立偿债基金，以便为日后可能对主要基础设施进行的维修和/或改进积累资金。与其预先收取一大笔金额，不如定期收取资金，以便长时间积累以备不时之需。
              </p>
            </li>

            <li>
              <strong> 乐古浪乡村联排别墅</strong>

              <p>
                公共区域由共管法人（CJP）进行管理。每年的费用由产生的总费用除以物业总数决定，并按比例分摊。特定项目的详细预估年费可应要求提供。此外，各项目还将设立偿债基金，以便为日后可能对主要基础设施进行的维修和/或改进积累资金。与其预先收取一大笔金额，不如定期收取资金，以便长时间积累以备不时之需。
              </p>
            </li>

            <li>
              <strong> 乐古浪乡村阁楼</strong>

              <p>
                公共区域由我们专门的物业管理部门代表业主进行管理。每年的费用由产生的总费用除以物业总数决定，并按比例分摊。特定项目的详细预估年费可应要求提供。此外，各项目还将设立偿债基金，以便为日后可能对主要基础设施进行的维修和/或改进积累资金。与其预先收取一大笔金额，不如定期收取资金，以便长时间积累以备不时之需。
              </p>
            </li>

            <li>
              <strong> 悦榕庄别墅</strong>

              <p>公共区域管理费将作为正常运作费用的一部分，由悦榕集团承担。</p>
            </li>
            <li>
              <strong> 都喜天阙泳池别墅</strong>
              <p>
                公共区域管理费将作为正常运作费用的一部分，由普吉岛乐古浪都喜天阙酒店承担。
              </p>
            </li>
          </ul>
        </div>
      ),
    },
  },
  {
    categoryId: 7,
    question: "What are the terms of payment?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            For all new properties sold, we offer 2 options of payment plans.
            Payment terms are as follows:
          </p>
          <p>
            <strong>
              Option 1: 100% Payment upon purchase / during construction
            </strong>
            <br />
            100% payment upon purchase for already completed properties.
            Progressive payments for properties under construction are as per
            the table below.
          </p>
          <table>
            <thead>
              <tr>
                <th>Construction Payment Term</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contact
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 25% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 50% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment when construction is 75% complete
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  5<sup>th</sup> Payment upon completion of construction
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Total</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>
                Areas and dimensions are approximate and subject to final survey
                and change.
              </small>
            </li>
            <li>
              <small>
                Prices include fixed furnishing and do not include loose
                furniture.
              </small>
            </li>
            <li>
              <small>Concrete structure substantially completed.</small>
            </li>
            <li>
              <small>
                Roof, brickwork and rendering substantially completed.
              </small>
            </li>
            <li>
              <small>
                Electrical conduits, pipework and plastering substantially
                completed.
              </small>
            </li>
            <li>
              <small>
                Interest will be applied to the post-construction deferred
                balance as outlined under Financing Option
              </small>
            </li>
          </ol>
          <p>
            <strong>
              Option 2: 50% payment upon purchase / during construction with 50%
              deferred payment over 1, 3 or 5 years
            </strong>
            <br />
            50% payment upon purchase for already completed properties.
            Progressive payments for properties under construction (50% during
            construction / 50% post construction) as per the table below
          </p>
          <table>
            <thead>
              <tr>
                <th>Deferred Payment Plan</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contract
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 50% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 75% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment upon completion of construction
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Post construction payments
                  <sup>4</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th>Financing Options</th>
                <th className="th-col2">
                  Interest Rate
                  <br />
                  (per annum)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 Year (4 quarterly installments)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 Year (12 quarterly installments)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 Year (20 quarterly installments)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>
                Areas and dimensions are approximate and subject to final survey
                and change.
              </small>
            </li>
            <li>
              <small>
                Prices include fixed furnishing and do not include loose
                furniture.
              </small>
            </li>
            <li>
              <small>Concrete structure substantially completed.</small>
            </li>
            <li>
              <small>
                Roof, brickwork and rendering substantially completed.
              </small>
            </li>
            <li>
              <small>
                Electrical conduits, pipework and plastering substantially
                completed.
              </small>
            </li>
            <li>
              <small>
                Interest will be applied to the post-construction deferred
                balance as outlined under Financing Option
              </small>
            </li>
          </ol>
          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Price</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Reservation Deposit</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Construction Completion <br />
                    Payment 50% (Minus Deposit)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Remaining Post Finance 50%</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>Monthly Installment</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 Year (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 Year (5%)</strong>
                </td>
                <td>
                  <strong>5 Year (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>10,000,000</td>
                <td>100,000</td>
                <td>4,900,000</td>
                <td>5,000,000</td>
                <td>1,273,525</td>
                <td>451,292</td>
                <td>298,456</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>20,000,000</td>
                <td>100,000</td>
                <td>9,900,000</td>
                <td>10,000,000</td>
                <td>2,547,050</td>
                <td>902,583</td>
                <td>596,912</td>
              </tr>
              <tr>
                <td>25,000,000</td>
                <td>100,000</td>
                <td>12,400,000</td>
                <td>12,500,000</td>
                <td>3,183,813</td>
                <td>1,128,229</td>
                <td>746,140</td>
              </tr>
              <tr>
                <td>30,000,000</td>
                <td>100,000</td>
                <td>14,900,000</td>
                <td>15,000,000</td>
                <td>3,820,575</td>
                <td>1,353,875</td>
                <td>895,368</td>
              </tr>
              <tr>
                <td>35,000,000</td>
                <td>100,000</td>
                <td>17,400,000</td>
                <td>17,500,000</td>
                <td>4,457,338</td>
                <td>1,579,520</td>
                <td>1,044,596</td>
              </tr>
              <tr>
                <td>40,000,000</td>
                <td>100,000</td>
                <td>19,900,000</td>
                <td>20,000,000</td>
                <td>5,094,100</td>
                <td>1,805,166</td>
                <td>1,193,824</td>
              </tr>
              <tr>
                <td>45,000,000</td>
                <td>100,000</td>
                <td>22,400,000</td>
                <td>22,500,000</td>
                <td>5,730,863</td>
                <td>2,030,812</td>
                <td>1,343,053</td>
              </tr>
              <tr>
                <td>50,000,000</td>
                <td>100,000</td>
                <td>24,900,000</td>
                <td>25,000,000</td>
                <td>6,367,625</td>
                <td>2,256,458</td>
                <td>1,492,281</td>
              </tr>
              <tr>
                <td>55,000,000</td>
                <td>100,000</td>
                <td>27,400,000</td>
                <td>27,500,000</td>
                <td>7,004,388</td>
                <td>2,482,104</td>
                <td>1,641,509</td>
              </tr>
              <tr>
                <td>60,000,000</td>
                <td>100,000</td>
                <td>29,900,000</td>
                <td>30,000,000</td>
                <td>7,641,150</td>
                <td>2,707,749</td>
                <td>1,790,737</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>All amounts are stated in Thai Baht (THB).</small>
            </li>
            <li>
              <small>
                The above table sets out the estimated payments required under
                the respective payment plans for selling prices between THB
                10,000,000 - 60,000,000.
              </small>
            </li>
            <li>
              <small>
                The estimated payments are indicative only and the developer /
                seller does not accept any responsibility or liability
                whatsoever for any inaccuracies or omissions.
              </small>
            </li>
            <li>
              <small>
                One year deferred plan is 12 equal monthly installments (3%
                interest applies).
              </small>
            </li>
            <li>
              <small>
                Three year deferred plan is 36 equal monthly installments (5%
                interest applies).
              </small>
            </li>
            <li>
              <small>
                Five year deferred plan is 60 equal monthly installments (7%
                interest applies).
              </small>
            </li>
            <li>
              <small>Payment terms are subject to change without notice.</small>
            </li>
          </ol>
        </div>
      ),
      ru: (
        <div>
          <p>
            Для всех новых объектов недвижимости мы предлагаем 2 варианта
            оплаты. Условия оплаты：
          </p>
          <p>
            <strong>
              Вариант 1: 100% оплата при покупке / во время строительства
            </strong>
            <br />
            100% оплата при покупке готовых объектов. Прогрессивные платежи для
            строящихся объектов в с нижеприведенной таблице.
          </p>
          <table>
            <thead>
              <tr>
                <th>Резервационный депозит</th>
                <th className="th-col2">Тайских Батах</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>й</sup> платеж при подписании договора
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>й</sup> при выполнении 25% строительных работ
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3<sup>й</sup> при выполнении 50% строительных работ
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4<sup>й</sup> при выполнении 75% строительных работ
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  5<sup>й</sup> при завершении строительства
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Итого</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечание:</small>
          <ol className="notes">
            <li>
              <small>
                Площади и размеры указаны приблизительно и могут изменяться по
                итогам финальных измерений.
              </small>
            </li>
            <li>
              <small>
                Цены включают встроенную меблировку; невстроенная мебель не
                включена.
              </small>
            </li>
            <li>
              <small>Бетонная конструкция в основном завершена.</small>
            </li>
            <li>
              <small>
                Крыша, укладка кирпича и наружная отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                Электрическая проводка, укладка водопроводных труб и внутренняя
                отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                Проценты по рассрочке будут начислены на отложенные платежи по
                окончании строительства, как указано в таблице «Варианты
                финансирования»
              </small>
            </li>
          </ol>
          <p>
            <strong>Вариант 2: Оплаты в рассрочку</strong>
            Первые 50% по этапам строительства и вторые 50% в рассрочку в
            течение 1, 3 или 5 лет в зависимости от выбранного плана оплаты.
            <br />
            50% оплаты при покупке завершенных объектов и оплата в рассрочку для
            строящихся объектов (50% по этапам строительства / 50% после
            завершения строительства) смотрите таблицу изложенную ниже.
          </p>

          <table>
            <thead>
              <tr>
                <th>Резервационный депозит</th>
                <th className="th-col2">Тайских Батах</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>й</sup> платеж при подписании договора
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>й</sup> при выполнении 50% строительных работ
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3<sup>й</sup> при выполнении 75% строительных работ
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4<sup>й</sup> при завершении строительства
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Платеж после завершения строительства
                  <sup>4</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>Варианты финансирования</th>
                <th className="th-col2">
                  Процентная
                  <br />
                  ставка
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 год (4 ежеквартальных платежа)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 года (12 ежеквартальных платежей)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 лет (20 ежеквартальных платежей)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечание:</small>
          <ol className="notes">
            <li>
              <small>
                Площади и размеры указаны приблизительно и могут изменяться по
                итогам финальных измерений.
              </small>
            </li>
            <li>
              <small>
                Цены включают встроенную меблировку; невстроенная мебель не
                включена.
              </small>
            </li>
            <li>
              <small>Бетонная конструкция в основном завершена.</small>
            </li>
            <li>
              <small>
                Крыша, укладка кирпича и наружная отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                Электрическая проводка, укладка водопроводных труб и внутренняя
                отделка в основном завершены.
              </small>
            </li>
            <li>
              <small>
                Проценты по рассрочке будут начислены на отложенные платежи по
                окончании строительства, как указано в таблице «Варианты
                финансирования»
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Цена</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Депозит</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Оплата 50% при
                    <br />
                    подписание контракта
                    <br />
                    (минус депозит)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Оплата вторых
                    <br />
                    50% после
                    <br />
                    завершения строительства
                  </strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>Ежемесячные платежи</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 год (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 года (5%)</strong>
                </td>
                <td>
                  <strong>5 год (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>10,000,000</td>
                <td>100,000</td>
                <td>4,900,000</td>
                <td>5,000,000</td>
                <td>1,273,525</td>
                <td>451,292</td>
                <td>298,456</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>20,000,000</td>
                <td>100,000</td>
                <td>9,900,000</td>
                <td>10,000,000</td>
                <td>2,547,050</td>
                <td>902,583</td>
                <td>596,912</td>
              </tr>
              <tr>
                <td>25,000,000</td>
                <td>100,000</td>
                <td>12,400,000</td>
                <td>12,500,000</td>
                <td>3,183,813</td>
                <td>1,128,229</td>
                <td>746,140</td>
              </tr>
              <tr>
                <td>30,000,000</td>
                <td>100,000</td>
                <td>14,900,000</td>
                <td>15,000,000</td>
                <td>3,820,575</td>
                <td>1,353,875</td>
                <td>895,368</td>
              </tr>
              <tr>
                <td>35,000,000</td>
                <td>100,000</td>
                <td>17,400,000</td>
                <td>17,500,000</td>
                <td>4,457,338</td>
                <td>1,579,520</td>
                <td>1,044,596</td>
              </tr>
              <tr>
                <td>40,000,000</td>
                <td>100,000</td>
                <td>19,900,000</td>
                <td>20,000,000</td>
                <td>5,094,100</td>
                <td>1,805,166</td>
                <td>1,193,824</td>
              </tr>
              <tr>
                <td>45,000,000</td>
                <td>100,000</td>
                <td>22,400,000</td>
                <td>22,500,000</td>
                <td>5,730,863</td>
                <td>2,030,812</td>
                <td>1,343,053</td>
              </tr>
              <tr>
                <td>50,000,000</td>
                <td>100,000</td>
                <td>24,900,000</td>
                <td>25,000,000</td>
                <td>6,367,625</td>
                <td>2,256,458</td>
                <td>1,492,281</td>
              </tr>
              <tr>
                <td>55,000,000</td>
                <td>100,000</td>
                <td>27,400,000</td>
                <td>27,500,000</td>
                <td>7,004,388</td>
                <td>2,482,104</td>
                <td>1,641,509</td>
              </tr>
              <tr>
                <td>60,000,000</td>
                <td>100,000</td>
                <td>29,900,000</td>
                <td>30,000,000</td>
                <td>7,641,150</td>
                <td>2,707,749</td>
                <td>1,790,737</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>Все суммы указаны в Батах</small>
            </li>
            <li>
              <small>
                В таблице выше указаны предполагаемые платежи, в рамках
                соответствующих планов оплаты объектов, стоимостью между 10,000,
                000-60,000, 000 Бат.
              </small>
            </li>
            <li>
              <small>
                Платежи являются лишь ориентировочными и строитель / продавец не
                несет ответственность за любые неточности или ошибки.
              </small>
            </li>
            <li>
              <small>
                Оплата в рассрочку сроком на один год подразумевает выплату 12
                ежемесячных платежей (с учетом 3% годовых).
              </small>
            </li>
            <li>
              <small>
                Оплата в рассрочку сроком на три года подразумевает выплату 36
                ежемесячных платежей (с учетом 5% годовых).
              </small>
            </li>
            <li>
              <small>
                Оплата в рассрочку сроком на пять лет подразумевает выплату 60
                ежемесячных платежей (с учетом 7% годовых).
              </small>
            </li>
            <li>
              <small>
                Условия оплаты могут быть изменены без предварительного
                уведомления.
              </small>
            </li>
          </ol>
        </div>
      ),
      cn: (
        <div>
          <p>对于所有出售的新物业，我们提供两种付款计划。 付款方式如下：</p>
          <p>
            <strong>选择1：100% 购买价格付款或建造期间付款</strong>
            <br />
            对于已建成物业，依据购买价格100%付款。对于在建物业，依据下表按进度分期付款。
          </p>
          <table>
            <thead>
              <tr>
                <th>按建造分期付款</th>
                <th className="th-col2">销售价格</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>首笔款项于签订购买合同支付</td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>
                  第二笔款项于工程完成25%时支付
                  <sup>1</sup>
                </td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>
                  第三笔款项于工程完成50%时支付
                  <sup>2</sup>
                </td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>
                  第四笔款项于工程完成75%时支付
                  <sup>3</sup>
                </td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>第五笔款项于工程完成时支付</td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>总额</td>
                <td className="td-col2">销售价格的100%</td>
              </tr>
            </tbody>
          </table>
          <small>备注：</small>
          <ol className="notes">
            <li>
              <small>面积与尺寸仅为预估，实际数据以最终测绘为准</small>
            </li>
            <li>
              <small>价格包含装修，不包含可移动家具</small>
            </li>
            <li>
              <small>混凝土基础结构工程完成</small>
            </li>
            <li>
              <small>外墙及封顶工程完成</small>
            </li>
            <li>
              <small>水电工程，管道及水泥抹平工程完成</small>
            </li>
            <li>
              <small>
                利息将根据所选付款方案以截至竣工付款之后的剩余房款余额计算
              </small>
            </li>
          </ol>
          <p>
            <strong>
              选择2：50% 购买价格付款或建造期间付款，50%延期1年,3年或5年付款。
            </strong>
            <br />
            对于已建成物业，依据购买价格的50%付款。对于在建物业，依据下表按进度分期付款（50%建造期间支付
            / 50%建造完成时支付）。
          </p>

          <table>
            <thead>
              <tr>
                <th>预定金</th>
                <th className="th-col2">泰铢</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>首笔款项于签订购买合同支付</td>
                <td className="td-col2">销售价的20%</td>
              </tr>
              <tr>
                <td>
                  第二笔款项于工程完成50%之时支付
                  <sup>1</sup>
                </td>
                <td className="td-col2">销售价的10%</td>
              </tr>
              <tr>
                <td>
                  第三笔款项于工程完成75%时支付
                  <sup>2</sup>
                </td>
                <td className="td-col2">销售价的10%</td>
              </tr>
              <tr>
                <td>
                  第四笔款项于工程完工时支付
                  <sup>3</sup>
                </td>
                <td className="td-col2">销售价的10%</td>
              </tr>
              <tr>
                <td>
                  建成后支付
                  <sup>4</sup>
                </td>
                <td className="td-col2">销售价的50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>财务选择</th>
                <th className="th-col2">利率</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1年 (4 个季度分期)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3年 (12 个季度分期)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5年 (20 个季度分期)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>备注：</small>
          <ol className="notes">
            <li>
              <small>面积与尺寸仅为预估，实际数据以最终测绘为准</small>
            </li>
            <li>
              <small>价格包含装修，不包含可移动家具</small>
            </li>
            <li>
              <small>混凝土基础结构工程完成</small>
            </li>
            <li>
              <small>外墙及封顶工程完成</small>
            </li>
            <li>
              <small>水电工程，管道及水泥抹平工程完成</small>
            </li>
            <li>
              <small>
                利息将根据所选付款方案以截至竣工付款之后的剩余房款余额计算
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>售价</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>定金</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>施工期间付款50%</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>竣工后付款</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>竣工后—按月分期付款</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1年期计划利息为3%</strong>
                </td>
                <td className="td-title">
                  <strong>3年期计划利息为5%</strong>
                </td>
                <td>
                  <strong>5年计划利息为7%</strong>
                </td>
              </tr>
              <tr>
                <td>10,000,000</td>
                <td>100,000</td>
                <td>4,900,000</td>
                <td>5,000,000</td>
                <td>1,273,525</td>
                <td>451,292</td>
                <td>298,456</td>
              </tr>
              <tr>
                <td>15,000,000</td>
                <td>100,000</td>
                <td>7,400,000</td>
                <td>7,500,000</td>
                <td>1,910,288</td>
                <td>676,937</td>
                <td>447,684</td>
              </tr>
              <tr>
                <td>20,000,000</td>
                <td>100,000</td>
                <td>9,900,000</td>
                <td>10,000,000</td>
                <td>2,547,050</td>
                <td>902,583</td>
                <td>596,912</td>
              </tr>
              <tr>
                <td>25,000,000</td>
                <td>100,000</td>
                <td>12,400,000</td>
                <td>12,500,000</td>
                <td>3,183,813</td>
                <td>1,128,229</td>
                <td>746,140</td>
              </tr>
              <tr>
                <td>30,000,000</td>
                <td>100,000</td>
                <td>14,900,000</td>
                <td>15,000,000</td>
                <td>3,820,575</td>
                <td>1,353,875</td>
                <td>895,368</td>
              </tr>
              <tr>
                <td>35,000,000</td>
                <td>100,000</td>
                <td>17,400,000</td>
                <td>17,500,000</td>
                <td>4,457,338</td>
                <td>1,579,520</td>
                <td>1,044,596</td>
              </tr>
              <tr>
                <td>40,000,000</td>
                <td>100,000</td>
                <td>19,900,000</td>
                <td>20,000,000</td>
                <td>5,094,100</td>
                <td>1,805,166</td>
                <td>1,193,824</td>
              </tr>
              <tr>
                <td>45,000,000</td>
                <td>100,000</td>
                <td>22,400,000</td>
                <td>22,500,000</td>
                <td>5,730,863</td>
                <td>2,030,812</td>
                <td>1,343,053</td>
              </tr>
              <tr>
                <td>50,000,000</td>
                <td>100,000</td>
                <td>24,900,000</td>
                <td>25,000,000</td>
                <td>6,367,625</td>
                <td>2,256,458</td>
                <td>1,492,281</td>
              </tr>
              <tr>
                <td>55,000,000</td>
                <td>100,000</td>
                <td>27,400,000</td>
                <td>27,500,000</td>
                <td>7,004,388</td>
                <td>2,482,104</td>
                <td>1,641,509</td>
              </tr>
              <tr>
                <td>60,000,000</td>
                <td>100,000</td>
                <td>29,900,000</td>
                <td>30,000,000</td>
                <td>7,641,150</td>
                <td>2,707,749</td>
                <td>1,790,737</td>
              </tr>
            </tbody>
          </table>
          <small>备注：</small>
          <ol className="notes">
            <li>
              <small>所有金额均以泰铢表示。</small>
            </li>
            <li>
              <small>
                上表所列为售价介于1000万至6000万泰铢的物业在相应付款计划下规定的预计付款额。
              </small>
            </li>
            <li>
              <small>
                预计付款额仅作示意参考用途。如有错漏，开发商/销售方概不负责。
              </small>
            </li>
            <li>
              <small>
                一年期延期付款计划是指，分12个月按月等额分期付款（利息为3%）。
              </small>
            </li>
            <li>
              <small>
                三年期延期付款计划是指，分36个月按月等额分期付款（利息为5%）。
              </small>
            </li>
            <li>
              <small>
                五年期延期付款计划是指，分60个月按月等额分期付款（利息为7%）。
              </small>
            </li>
            <li>
              <small>付款方式如有更改，恕不另行通知。</small>
            </li>
          </ol>
        </div>
      ),
    },
  },
];

export { category, faqs };



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaVillageResidences/faq.js